export function extractHostname(url: string): string {
  try {
    const { hostname } = new URL(
      url.startsWith("http") ? url : `https://${url}`,
    );
    return hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

/**
 * Uses Google's favicon API to get the favicon for a given hostname
 */
export function getFaviconUrl(hostname: string): string {
  const encoded = encodeURIComponent(hostname);
  return `https://www.google.com/s2/favicons?domain=${encoded}&sz=16`;
}

/**
 * Cleans up text by replacing problematic Unicode characters and normalizing whitespace
 */
export function cleanUpSearchResultDescription(text: string): string {
  return text
    .replace(/[�]/g, "•") // Replace replacement characters with bullet points
    .replace(/\s+/g, " ") // Normalize whitespace
    .trim(); // Remove leading/trailing whitespace
}
